import React, { useContext, useEffect, useState } from "react";
import { Box } from "./components/styled/Elements";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { privateRoutes } from "./routes/privateRoutes";
import { publicRoutes } from "./routes/pubicRoutes";
import AdminLayout from "./layout/AdminLayout";
import "react-toastify/dist/ReactToastify.css";
import { AuthContext } from "./context/authContext";
import PrivateRoute from "./routes/PrivateRouteComponent";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import PermissionWrapper from "./components/admin/permissionWrapper/PermissionWrapper";
import { useUser } from "./context/userContext";
import PageNotFound from "./components/common/pageNotFound/PageNotFound";

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, fetchUserInfo } = useUser();
  const {
    i18n: { language },
  } = useTranslation();
  const { isAuthenticated } = useContext(AuthContext);

  const [filteredPrivateRoutes, setFilteredPrivateRoutes] =
    useState(privateRoutes);

  useEffect(() => {
    window.scroll({ top: 0, behaviour: "smooth" });
    if (location.pathname === "/") {
      if (isAuthenticated) {
        user?.user_type_id == 6
          ? navigate("/temporary-cabinets")
          : navigate("/dashboard");
      } else {
        navigate("/login");
      }
    }
    if (!isAuthenticated) {
      if (
        !["/login", "/signup", "/login-with-phone", "/reset-password"].includes(
          location.pathname
        )
      ) {
        navigate("/login");
      }
    }
    if (
      isAuthenticated &&
      (location.pathname === "/login" ||
        location.pathname === "/signup" ||
        location.pathname === "/login-with-phone" ||
        location.pathname === "/reset-password")
    ) {
      if (Number(user?.user_type_id) === 6) navigate("/cabinets");
      else navigate("/dashboard");
    }
  }, [location]);

  useEffect(() => {
    if (user && user?.user_type_id !== 2) {
      if (Number(user?.user_type_id) === 6) {
        setFilteredPrivateRoutes(
          privateRoutes.filter(
            (route) =>
              !route.path.includes("settings") && route.path !== "dashboard"
          )
        );
      } else {
        setFilteredPrivateRoutes(
          privateRoutes.filter(
            (route) =>
              route.path !== "settings/admin-director" &&
              route.path !== "settings/admin-director/edit"
          )
        );
      }
    }
  }, [user]);

  return (
    <>
      <ToastContainer
        position={language === "ar" ? "top-left" : "top-right"}
        rtl={language === "ar"}
      />
      <Box>
        <Routes>
          {publicRoutes.map((route, key) => (
            <Route key={key} {...route} />
          ))}
          <Route path="/" element={<AdminLayout />}>
            {filteredPrivateRoutes.map((route, key) => (
              <Route
                key={key}
                path={route.path}
                element={
                  <PermissionWrapper
                    isPermitted={!!route?.permission}
                    moduleId={route?.permission?.collection}
                    actionId={route?.permission?.action}
                    featureId={route?.permission?.feature}
                  >
                    <PrivateRoute
                      isAuthenticated={isAuthenticated}
                      element={route.element}
                      list={route}
                    />
                  </PermissionWrapper>
                }
              />
            ))}
            {isAuthenticated && (
              <Route
                path="*"
                element={
                  <PageNotFound
                    btnUrl={
                      isAuthenticated
                        ? user?.user_type_id == 6
                          ? "/temporary-cabinets"
                          : "/dashboard"
                        : "/login"
                    }
                    btnLabel={isAuthenticated ? "home" : "login"}
                  />
                }
              />
            )}
          </Route>
        </Routes>
      </Box>
    </>
  );
};

export default App;
